import QuestionValue from "./QuestionValue";

export default class QuestionValueStringToFloat extends QuestionValue {
    constructor(string) {
        super(isNaN(string) ? NaN : parseFloat(string));

        this._string = string;
    }

    toString() {
        return this._string;
    }
}